<illegal-mail>
  <div class="illegal-title">身に覚えのないメールの連絡</div>
  <p>身に覚えのないメールを受信した場合は、以下のボタンを押してご連絡ください。</p>
  <button
    class="btn btn-green"
    onclick="{ props.onNotifyClick }"
  >連絡する</button>
  <div class="link-group">
    <a href="#login"><i class="fas fa-angle-double-left"></i>ログイン画面へ戻る</a>
  </div>
</illegal-mail>